export default __webpack_public_path__ + "static/media/480_store04-es-web.efa3aec6.png";